export default [
  { label: "Produto", value: "name" },
  { label: "Quantidade", value: "quantity" },
  { label: "Valor Un.", value: "unitValue" },
  { label: "Valor final", value: "totalValue" },
];
